module.exports = __webpack_public_path__ + "img/logo_white.png?5914a6ebc2140bc5c4614912bbd56c37";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_white.png
// module id = 257
// module chunks = 0